
<div class="mat-container">
<div mat-dialog-title>   </div>
<div mat-dialog-content style="text-align: center;">
  Are you sure<br>
  You want to cancel the subscription
</div>


<!-- <button type="button"  mat-flat-button>Clear</button> -->
<div mat-dialog-actions class="buttons">
    <button mat-flat-button mat-dialog-close>No</button>
    <button type="button" mat-flat-button mat-dialog-close  color="primary"> Yes</button>
</div>     

</div>
<!-- <button type="button" (click)="clear()" mat-flat-button>Clear</button>
    <button type="button" (click)="onSubmit()" mat-flat-button color="primary">Save</button> -->